export default __webpack_public_path__ + "static/media/vertical-banner1.c6b058d3.jpg";